import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { BUSINESS } from "@/data/cybernet";

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waHref = `https://wa.me/${BUSINESS.primaryWhatsapp}?text=${encodeURIComponent(
    "Hola CYBERNET, me interesa conocer más sobre sus servicios."
  )}`;

  return (
    <div
      data-testid="whatsapp-float-wrapper"
      className={`fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {open && (
        <div
          data-testid="whatsapp-float-card"
          className="bg-white border border-[#E4E4E7] rounded-sm p-5 shadow-2xl max-w-[280px] animate-in fade-in slide-in-from-bottom-4"
        >
          <div className="flex items-start justify-between mb-3">
            <div>
              <div className="font-display font-bold text-sm text-[#0A0A0A]">
                ¿En qué te ayudamos?
              </div>
              <div className="text-xs text-[#52525B]">
                Responderemos a la brevedad
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-[#52525B] hover:text-[#0A0A0A]"
              aria-label="Cerrar"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-float-cta"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#E10600] text-white text-sm font-semibold px-4 py-2.5 rounded-sm hover:bg-[#B30500]"
          >
            <MessageCircle className="h-4 w-4" />
            Abrir WhatsApp
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-floating-btn"
        aria-label="Contactar por WhatsApp"
        className="relative h-14 w-14 rounded-full bg-[#E10600] text-white shadow-2xl flex items-center justify-center hover:scale-110 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#E10600] animate-ping opacity-30" />
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
};
